import { PhoneCall } from 'src/models/phoneCall';

import { Callback } from 'src/util/query/models/Callback';

export class PhoneCallCallback extends Callback<PhoneCall> {
	public constructor(private readonly setPhoneCall: (phoneCall: PhoneCall | null) => void) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: PhoneCall): void => {
		const phoneCall = successResponse;
		if (phoneCall.callReason != null) {
			phoneCall.callReason = phoneCall.callReason.replace(/\n/g, '<br />');
		}

		this.setPhoneCall(phoneCall);
	};
}
